import { MatchedDocumentGroup } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/ManageFileAssociationStep/ManageFileAssociationStep.types';
import { MatchedDocumentsRes } from '@dealstack/shared/lib/generated';

/**
 * Collapses the backend's one-row-per-link response into one entry per document.
 *
 * `File.md5` carries no unique constraint, so a single md5 can match several documents, and each
 * of those contributes a row per link. Reading `matchedDocuments[0]` therefore named an arbitrary
 * document and hid the rest.
 */
export const groupMatchedDocuments = (
	matchedDocuments: MatchedDocumentsRes[]
): MatchedDocumentGroup[] => {
	const groupsByDocumentId = new Map<string, MatchedDocumentGroup>();

	for (const matchedDocument of matchedDocuments) {
		const group = groupsByDocumentId.get(matchedDocument.documentId) ?? {
			documentId: matchedDocument.documentId,
			fileId: matchedDocument.fileId,
			documentName: matchedDocument.documentName,
			links: [],
		};

		// An unlinked document still produces a row, with both ids null on it.
		if (matchedDocument.personId || matchedDocument.linkedTransactionId) {
			group.links.push(matchedDocument);
		}

		groupsByDocumentId.set(matchedDocument.documentId, group);
	}

	return [...groupsByDocumentId.values()];
};
